module.exports = require("core-js-pure/features/object/keys");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/keys.js
// module id = 492
// module chunks = 13